/*
 * Public API Surface of sdk-loading
 */

export { SDKMessageModule } from './lib/sdk-message.module';
export { SDKMessageComponent } from './lib/sdk-message.component';
